<template>
    <div class='official-home-container'>
        <img src="../../../public/static/images/official/home/1.png" alt="">
        <img src="../../../public/static/images/official/home/2.png" alt="">
        <img src="../../../public/static/images/official/home/3.png" alt="">
        <img src="../../../public/static/images/official/home/4.png" alt="">
    </div>
</template>

<script>

export default {
    name: '',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {},
}
</script>
<style lang='less' scoped>
.official-home-container {
    font-size: 0;

    img {
        width: 100%;
        vertical-align: top;
        margin-top: -2px;
    }
}
</style>